'use client'

import { usePathname } from 'next/navigation'
import { useEffect, useRef } from 'react'

/**
 * Sends GA4 page_view on client-side route changes. The initial landing
 * page_view is emitted by the GA4 config tag itself (send_page_view), so we skip
 * the first render here to avoid a duplicate landing hit, then report every
 * subsequent App Router navigation. A dataLayer signal is also pushed, reserved
 * for marketing pixels (Meta/TikTok/Pinterest) that are not yet installed.
 */
export function usePageViewTracking() {
  const pathname = usePathname()
  const isInitialLoad = useRef(true)

  useEffect(() => {
    if (!pathname) return
    if (isInitialLoad.current) {
      isInitialLoad.current = false
      return
    }

    window.gtag?.('event', 'page_view', {
      page_path: pathname,
      page_location: window.location.href,
      page_title: document.title,
    })
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({ event: 'page_view', page_path: pathname })
    // Meta PageView per SPA navigation. The initial landing PageView comes from
    // the MetaPixel bootstrap itself — skipping the first render here (above)
    // is what prevents the classic App Router double-PageView. fbq exists only
    // when consent allowed the pixel to load.
    window.fbq?.('track', 'PageView')
  }, [pathname])
}
